import React from 'react';
import { Container } from 'react-bootstrap';

/* import HeaderSection from '../components/HeaderSection';
import TopSimpleSection from '../components/TopSimpleSection'; */
import TopMenu from '../components/Navbar/Navbar';
/* import SimpleSection from '../components/SimpleSection'; */
//import Footer from '../components/Footer';
/* import WBkey from '../components/WBkey';
import Subscribe from '../components/Subscribe'; */
import ItemHeaderLoading from '../components/loading/ItemHeaderLoading';
import Footer from '../components/Footer/Footer';
import Back2TopBtn from '../components/Back2TopBtn';

export default function AboutLayout(props) {
	//const { title, subtitle, backgroundImage, children, search, button,colection, news, agencyData} = props;
	return (
		<div className='c-main-wrapper c-ilay'>
			<TopMenu background='white' />
			<ItemHeaderLoading />
			<Container className='gv-loading'>
				<div className='spac'></div>
			</Container>
			<Back2TopBtn/>
			<Footer />
			{/*<div className='pfoot'>
				Pseudofooter
			</div>*/}
		</div>
	);
}
